import {i18n} from "./i18n";
import UrlHelpers from "./url";

import * as mdc from "material-components-web";
import {MediamanagerFileInputHandler} from "./mediamanagerFileInput";


export class ConfigTerms {
    private _dapi: Dapi = (<any>window).dapi;
    private _i18n: i18n = new i18n();

    constructor() {
        this._loadMaterial();
        this._loadEventListeners();

        if (this._dapi.isMainResource()) {
            this._dapi.publishLocation(location.href);
        }
    }

    private _loadMaterial = () => {
        const uLists = document.querySelectorAll('.mdc-list');
        if (uLists) {
            uLists.forEach((list) => {
                mdc.list.MDCList.attachTo(list);
            });
        }
    };

    private _loadEventListeners = () => {
        const listItems = document.querySelectorAll('.mdc-list-item');
        if (listItems) {
            Array.apply(null, listItems).forEach((li: HTMLLIElement) => {
                li.addEventListener('click', this._showDocument);
            });
        }

        const uploadButtons = document.querySelectorAll('.config-upload');
        if (uploadButtons) {
            Array.apply(null, uploadButtons).forEach((button: HTMLButtonElement) => {
                button.addEventListener('click', this._saveTemplate);
            })
        }

        const deleteButtons = document.querySelectorAll('.config-delete');
        if (deleteButtons) {
            Array.apply(null, deleteButtons).forEach((button: HTMLButtonElement) => {
                button.addEventListener('click', this._deleteTemplate);
            })
        }
    };

    private _makeRequest = (url: string, method: HTTPMethods, data: any, headers: HeadersInit, wantStatus: number, cbSuccess: ()=>void, cbError: (string)=>void) => {
        if (!url || url ==="") {
            console.warn('Parameter "url" was empty or null');
            return;
        }
        console.info(`Request ${method} with target: ${url}`);
        fetch(url, {
            method: method,
            body: JSON.stringify(data),
            headers: headers,
            credentials: "same-origin"
        }).then(r => {
            if (r.status != wantStatus) {
                if (cbError) {
                    console.info(`Response of request ${method} unexpected: Want status ${wantStatus}, got `, status);
                    cbError(r.status);
                }
                return;
            }
            if (cbSuccess) {
                cbSuccess();
            }
        }).catch(e => {
            console.error(`Error: `, e);
            if (cbError) {
                cbError(e.toString());
            }
        });
    };

    private _saveTemplate = (e: Event) => {
        let mmInput = <HTMLInputElement>document.getElementById('config_template_mediamanager_input');
        if (!mmInput) {
            console.error('Cannot find element with ID "config_template_mediamanager_input"');
            return;
        }
        const targetParent = (<HTMLButtonElement>e.target).parentElement;
        if (!targetParent || !targetParent.hasAttribute(DataAttributes.KEY)) {
            console.warn('Cannot find parent of target or data-attribute: ', (<HTMLElement>e.target).id);
            return;
        }
        //replace input to clear event listeners so the input won't have multiple event listener of the same kind
        mmInput = this._replaceAndClearInput(mmInput);
        this._initializeMediaManager(mmInput, (source) => {
            this._patchRequest(targetParent.getAttribute(DataAttributes.KEY), source, () => {
                targetParent.setAttribute(DataAttributes.VALUE, source);
                this._showUploadSuccess();
            }, this._showUploadFailed);
        });
        mmInput.dispatchEvent(new MouseEvent('click'));
    };

    private _deleteTemplate = (e: Event) => {
        const targetParent = (<HTMLButtonElement>e.target).parentElement;
        if (!targetParent || !targetParent.hasAttribute(DataAttributes.KEY) || !targetParent.hasAttribute(DataAttributes.VALUE)) {
            console.log('Cannot find parent of target or data-attribute: ', (<HTMLElement>e.target).id);
            return;
        }
        this._deleteRequest(targetParent.getAttribute(DataAttributes.KEY), targetParent.getAttribute(DataAttributes.VALUE), () => {
            targetParent.setAttribute(DataAttributes.VALUE, "");
            this._showDeleteSuccess();
        }, this._showDeleteFailed);
    };

    private _deleteRequest = (key: string, value: string, cbSuccess: ()=>void, cbError: (string)=>void) => {
        this._configApiRequest(HTTPMethods.DELETE, key, value, cbSuccess, cbError);
    };

    private _patchRequest = (key: string, value: string, cbSuccess: ()=>void, cbError: (string)=>void) => {
        this._configApiRequest(HTTPMethods.PATCH, key, value, cbSuccess, cbError);
    };

    private _configApiRequest = (method: HTTPMethods, key: string, value: string, cbSuccess: ()=>void, cbError: (string)=>void) => {
        if (!key || key === "") {
            console.warn('Parameter "key" was empty or null');
            return;
        }
        if (!value || value === "") {
            console.warn('Parameter "value" was empty or null');
            return;
        }
        const url = this._getUrl();
        if (!url || url === "") {
            console.warn('URL was empty or null');
            return;
        }
        this._makeRequest(url, method, {
            key: key,
            value: value
        }, {
            'accept': 'application/json',
            'content-type': 'application/json'
        }, 200, cbSuccess, cbError);
    };

    private _initializeMediaManager = (input: HTMLInputElement, cb: (string)=>void) => {
        if (!input) {
            console.warn('Parameter "input" was empty or null');
        }
        new MediamanagerFileInputHandler(input, (source) => {
            if (cb) {
                cb(source);
            }
        });
    };

    private _replaceAndClearInput = (input: HTMLInputElement): HTMLInputElement => {
        const clone= <HTMLInputElement>input.cloneNode(true);
        clone.value = "";
        input.parentNode.replaceChild(clone, input);
        return clone;
    };

    private _showNotification = (id: string, message: string) => {
        let div = <HTMLDivElement>document.getElementById(id);
        if (div) {
            let bar = new mdc.snackbar.MDCSnackbar(div);
            bar.labelText = message;
            bar.closeOnEscape = true;
            bar.open();
        }
    };

    private _showUploadSuccess = () => {
        this._showNotification('config-notification', this._i18n.getTranslation('config_terms_notificaton_success'));
    };

    private _showUploadFailed = (message:string) => {
        if (message) {
            console.warn("Upload request failed. Message: ", message);
        }
        this._showNotification('config-notification', this._i18n.getTranslation('config_terms_notificaton_failed'));
    };

    private _showDeleteSuccess = () => {
        this._showNotification('config-notification', this._i18n.getTranslation('config_terms_notificaton_success_delete'));
    };

    private _showDeleteFailed = (message:string) => {
        if (message) {
            console.warn("Delete request failed. Message: ", message);
        }
        this._showNotification('config-notification', this._i18n.getTranslation('config_terms_notificaton_failed_delete'))
    };

    private _showDocument = (e: Event) => {
        const target = <HTMLLIElement>e.target;
        const attIdent = DataAttributes.VALUE;
        if (target.hasAttribute(attIdent) && target.getAttribute(attIdent).length > 0) {
            window.open(target.getAttribute(attIdent));
        }
    };

    private _getUrl = (): string => {
        return UrlHelpers.getLinkRelHref('self');
    };
}

enum DataAttributes {
    KEY = 'data-key',
    VALUE = 'data-template'
}

enum HTTPMethods {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH'
}
